import React from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import { SpheraButtonEx, SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import CustomColumnLocalizationGridColumns from "../../Data/CustomColumnLocalizationGridColumns.json";
import { ColumnManager } from "../../services/columnManager";
import { CommandCell } from "../Grid/Cell/CommandCell";
import { DropdownCell } from "../Grid/Cell/DropdownCell";
import { ColumnNameCell } from "../Grid/Cell/ColumnNameCell";
import { process } from "@progress/kendo-data-query";

export function CustomColumnLocalizationModal(props) {
    const editField = "inEdit";
    const GridContext = React.createContext({});
    const CommandCellConst = (props) => {
        const { enterEdit, remove, add, discard, update, cancel, editField } =
            React.useContext(GridContext);
        return (
            <CommandCell
                {...props}
                edit={enterEdit}
                remove={remove}
                add={add}
                discard={discard}
                update={update}
                cancel={cancel}
                editField={editField}
            />
        );
    };

    const { columnResize, columnReorder } = ColumnManager(CustomColumnLocalizationGridColumns, "CustomColumnGridSettings");

    const insertItem = (item) => {
        item.LocalizationId = 0;
        props.setnewId(props.newId - 1);
        item.inEdit = false;
        return props.selectedColumn.customerColumns[0].columnLocalizations;
    };
    const updateItem = (item) => {
        let index = props.selectedColumn.customerColumns[0].columnLocalizations.findIndex((record) => record.columnLocalizationId === item.columnLocalizationId);
        props.selectedColumn.customerColumns[0].columnLocalizations[index] = item;
        return props.selectedColumn.customerColumns[0].columnLocalizations;
    };
    const deleteItem = (item) => {
        let index = props.selectedColumn.customerColumns[0].columnLocalizations.findIndex((record) => record.columnLocalizationId === item.columnLocalizationId);
        props.selectedColumn.customerColumns[0].columnLocalizations.splice(index, 1);
        return props.selectedColumn.customerColumns[0].columnLocalizations;
    };

    const remove = (dataItem) => {
        const newData = deleteItem(dataItem);
        props.selectedColumn.customerColumns[0].columnLocalizations = newData;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const add = (dataItem) => {
        dataItem.inEdit = true;
        const newData = insertItem(dataItem);
        props.selectedColumn.customerColumns[0].columnLocalizations = newData;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const update = (dataItem) => {
        dataItem.inEdit = false;
        dataItem.isNew = false;
        const newData = updateItem(dataItem);
        props.selectedColumn.customerColumns[0].columnLocalizations = newData;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };

    // Local state operations
    const discard = (dataItem) => {
        let newData = props.selectedColumn.customerColumns[0].columnLocalizations;
        const index = props.selectedColumn.customerColumns[0].columnLocalizations.findIndex(x => x.columnLocalizationId === dataItem.columnLocalizationId);
        newData.splice(index, 1);
        props.selectedColumn.customerColumns[0].columnLocalizations = newData;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const cancel = (dataItem) => {
        const originalItem = props.selectedColumn.customerColumns[0].columnLocalizations.find(
            (p) => p.columnLocalizationId === dataItem.columnLocalizationId
        );
        originalItem.isEdit = false;
        const newcolumnLocalizations = props.selectedColumn.customerColumns[0].columnLocalizations.map((item) =>
            item.columnLocalizationId === originalItem.columnLocalizationId ? originalItem : item
        );
        props.selectedColumn.customerColumns[0].columnLocalizations = newcolumnLocalizations;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const enterEdit = (dataItem) => {
        const newcolumnLocalizations = props.selectedColumn.customerColumns[0].columnLocalizations.map((item) =>
            item.columnLocalizationId === dataItem.columnLocalizationId
                ? {
                    ...item,
                    inEdit: true,
                }
                : item
        );
        props.selectedColumn.customerColumns[0].columnLocalizations = newcolumnLocalizations;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const itemChange = (event) => {
        const field = event.field || "";
        const newcolumnLocalizations = props.selectedColumn.customerColumns[0].columnLocalizations.map((item) =>
            item.columnLocalizationId === event.dataItem.columnLocalizationId
                ? {
                    ...item,
                    [field]: event.value,
                }
                : item
        );
        props.selectedColumn.customerColumns[0].columnLocalizations = newcolumnLocalizations;
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };
    const addNew = () => {
        const newDataItem = {
            inEdit: true,
            isNew: true,
            localeId: 0,
            columnLocalizationId: props.newId
        };
        props.setnewId(props.newId - 1);
        props.selectedColumn.customerColumns[0].columnLocalizations.push(newDataItem);
        props.setselectedColumn(props.selectedColumn);
        props.setlocalizationsDataResult(process(props.selectedColumn.customerColumns[0].columnLocalizations, props.localizationsDataState));
    };

    return (
        <div>
            {props.showCustomColumnModal && (
                <SpheraModal className="MaterialSynoymsModal" title={props.localizations[props.selectedColumn.title] == null ? props.selectedColumn.title : props.localizations[props.selectedColumn.title]} width={700} height="440px" onClose={props.toggleCustomColumn} noFooter={true} >
                    <div >
                        <GridContext.Provider
                            value={{
                                enterEdit: enterEdit,
                                remove: remove,
                                add: add,
                                discard: discard,
                                update: update,
                                cancel: cancel,
                                editField,
                            }}
                        >
                        <Grid
                            className="sphera-grid"
                            style={{
                                height: '330px',
                                width: '95%',
                                marginLeft: "auto",
                                marginRight: "auto",
                                marginTop: "10px",
                                maxHeight: '380px'
                                }}
                                onItemChange={itemChange}

                                editField={editField}
                                data={props.dataResult}
                                {...props.dataState}
                                onDataStateChange={props.dataStateChange}
                            sortable={true}
                            reorderable={true}
                            resizable={true}
                            scrollable="scrollable"
                            onColumnReorder={columnReorder}
                            onColumnResize={columnResize}
                            pageable={{
                                buttonCount: 4,
                                pageSizes: [25, 50, 100]
                            }}
                        >
                            <GridToolbar>
                                <SpheraTooltip anchor="target" position="top">
                                        <SpheraButtonEx style={{ height: '32px' }} primary text={props.localizations.AddLocalization} onClick={() => addNew()} />
                                </SpheraTooltip>
                            </GridToolbar>
                                <Column
                                    cell={(props2) => <ColumnNameCell {...props2} languages={props.languages} />}
                                    field="localization"
                                    minResizableWidth={100}
                                    title={props.localizations.Localization}
                                    filter="text"
                                />
                                <Column
                                    cell={(props2) => <DropdownCell {...props2} languages={props.languages} otherLanguages={props.selectedColumn.customerColumns[0].columnLocalizations} />}
                                    field="localeId"
                                    minResizableWidth={100}
                                    title={props.localizations.Language}
                                    filter="text"
                                />
                                <Column cell={CommandCellConst} width="150px"  minResizableWidth={100} filterable={false} />
                            </Grid>

                        </GridContext.Provider>
                    </div>
                </SpheraModal>
            )}
        </div>
    );
}